import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { REQUEST_STATE, UseFetchRefs } from "../../dataTypes";
import mapUseFetchRefs from "../../utils/mapUseFetchRefs";
import mergeFetchedTimestampRefAndStateEntities from "../../utils/mergeFetchedTimestampRefAndStateEntities";
import { selectWebOrderEntities } from "../webOrderSelectors";
import { fetchWebOrder } from "../reducers/fetchWebOrder";
import { useValidateUserIsLoggedIn } from "../../utils/useValidateUserIsLoggedIn";
import { setError } from "../../dialog/dialogSlice";

let refs: UseFetchRefs;

const useFetchWebOrder = () => {
  const dispatch = useAppDispatch();
  const result = useValidateUserIsLoggedIn();

  const webOrders = useAppSelector(selectWebOrderEntities);

  if ((refs as UseFetchRefs | undefined) === undefined) {
    refs = mapUseFetchRefs(webOrders);
  }

  useEffect(() => {
    refs = mergeFetchedTimestampRefAndStateEntities(refs, mapUseFetchRefs(webOrders));
  }, [webOrders]);

  const loadWebOrder = useCallback(
    async (id?: string) => {
      if (result.isError) {
        dispatch(setError({ value: result.errorMessage }));
      } else {
        if (id) {
          const ref = refs[id];

          if (!ref || ref.requestState !== REQUEST_STATE.PENDING) {
            refs[id] = { fetchedTimestamp: Date.now(), requestState: REQUEST_STATE.PENDING };
            await dispatch(fetchWebOrder(id));
          }
        }
      }
    },
    [dispatch, result],
  );

  return loadWebOrder;
};

export default useFetchWebOrder;
